import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { fhirR4 } from '@smile-cdr/fhirts';
import { ResourceType } from '../models/ResourceType';

@Injectable({
  providedIn: 'root',
})
export class ParserService {
  private readonly translate = inject(TranslateService);

  getFirstOrUndefined<T>(arr: T[] | undefined): T | undefined {
    return arr && arr.length > 0 ? arr[0] : undefined;
  }

  // will be replaced by coverage extension
  getCoverageId(resource: fhirR4.Resource): string {
    let insurance;
    const resourceType = resource.resourceType;
    switch (resourceType) {
      case 'ServiceRequest':
        insurance = (resource as fhirR4.ServiceRequest).insurance;
        break;
      case 'DeviceRequest':
        insurance = (resource as fhirR4.DeviceRequest).insurance;
        break;
      default:
        throw new Error(this.translate.instant('Error.NoCoverage'));
    }
    return insurance[0].reference;
  }

  formatName(names: fhirR4.HumanName[] | undefined): string {
    let firstName: fhirR4.HumanName | undefined;
    firstName = names?.find(
      (name) => name.use === fhirR4.HumanName.UseEnum.Official,
    );
    if (!firstName) {
      firstName = this.getFirstOrUndefined(names);
    }

    if (firstName) {
      return (firstName.prefix || [])
        .concat(
          firstName.given || [],
          firstName.family ? [firstName.family] : [],
        )
        .join(' ');
    }
    return '';
  }

  getQuestionnaireFromPackage(qPackage: fhirR4.Bundle) {
    return this.getQuestionnaireEntryFromPackage(qPackage)
      ?.resource as fhirR4.Questionnaire;
  }

  getQuestionnaireEntryFromPackage(qPackage: fhirR4.Bundle) {
    return qPackage.entry?.find(
      (entry) => entry.resource?.resourceType === ResourceType.Questionnaire,
    );
  }
}
